import { Calendar } from 'primereact/calendar';

import { useState } from "react";


function DateEditor({
    data,
    label,
    placeholder,
    // onChange,
    onBlur,
    message,
    attr,
    options,
    ...arr
}) {

    const [value, setValue] = useState(new Date(data?.[attr]))
    function onChange(e){
        setValue(new Date(e.target.value))
        onBlur(e, attr, new Date(e.target.value));
    }
    
    return (<>
        <div className="flex justify-content-center">
            <div className="editor">
                <label className="editor_label" htmlFor={label}>{label}</label>
                <Calendar className="p-inputtext-dd" 
                    id={label} 
                    aria-describedby="username-help" 
                    // placeholder={placeholder} 
                    value={value}
                    options={options}
                    dateFormat='dd.mm.yy'
                    {...arr}
                    // placeholder={data?.[attr]} 
                    onChange={onChange} 
                    />
                {
                    message ?
                        <small id="username-help">
                            {message}
                        </small> : ""
                }
            </div>
        </div>
    </>);
}

export default DateEditor;